import React, { useEffect, useState } from "react";
import { forwardToNewDesign } from "../../utils/forwardToNewDesign";
import { useNavigate } from "react-router-dom";
import { postRequest } from "../../services/api/apiService";
import { getAuthToken } from "../../utils/auth";

const ShopifyOAuthAdsCallback = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (forwardToNewDesign()) return; // tunnel lancé depuis un autre client OneBotAds
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");
    const shop = queryParams.get("shop");
    const token = getAuthToken();

    if (!code || !shop) {
      setError("Authorization code or shop name missing.");
      return;
    }

    try {
      postRequest(
        "/api/ads-auth/shopify-oauth-ads/callback",
        { code, shop },
        { Authorization: `Bearer ${token}` }
      )
        .then((response) => {
          if (response.success) {
            navigate("/dashboard/shopify-ads");
          } else {
            setError("Failed to save Shopify OAuth Ads account details.");
            navigate("/error");
          }
        })
        .catch((error) => {
          setError(
            "Error during the Shopify OAuth Ads authentication process."
          );
          navigate("/error");
        });
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  }, [navigate]);

  return <div>{error && <p>{error}</p>}</div>;
};

export default ShopifyOAuthAdsCallback;
